// Wrapper de API para Hub Settings (Configurações).

import api from "./api";

export async function getSettings() {
  const { data } = await api.get("/settings");
  return data;
}

export async function updateSettings(payload) {
  // payload: { 'hub.x.y': value, ... }
  const { data } = await api.put("/settings", payload);
  return data;
}
